import React from "react";
import qs from "qs";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import { Steps } from "antd";
import { withTranslation } from "react-i18next";
import * as R from "ramda";
import { dispatchOnMount, dispatchOnUnmount } from "@worcket/common/hocs";

import DetailsForm from "../routes/OpportunityDetails/DetailsForm";
import MediaForm from "../routes/OpportunityDetails/MediaForm";
import ProcessForm from "../routes/OpportunityDetails/ProcessForm";
import CandidateForm from "../routes/OpportunityDetails/CandidateForm";
import ScreeningForm from "../routes/OpportunityDetails/ScreeningForm";
import {
  NEW_OPPORTUNITY,
  DESELECT_OPPORTUNITY
} from "../../../store/actions/opportunity";

import Publishing from "./Publishing";

import styled from "styled-components/macro";

const steps = [
  {
    id: "details",
    component: DetailsForm
  },
  {
    id: "candidates",
    component: CandidateForm
  },
  {
    id: "screening",
    component: ScreeningForm
  },
  {
    id: "media",
    component: MediaForm
  },
  {
    id: "publishing",
    component: Publishing
  },
  {
    id: "process",
    component: ProcessForm
  }
];

const Container = styled.div`
  overflow: auto;

  .center {
    max-width: 1200px;
    margin: 0 auto;

    .steps-menu {
      margin: 32px 32px 10px 32px;
    }

    .ant-steps-item-title {
      font-size: 12px;
      color: ${({ theme }) => theme["@gray-60"]};
    }

    .ant-steps-item-process .ant-steps-item-title {
      font-weight: normal;
      color: ${({ theme }) => theme["@primary"]};
    }
  }
`;

const NewOpportunity = ({ current, selected, t, initialValues }) => {
  const StepContent = steps[current].component;

  return (
    <Container>
      <div className="center">
        <div className="steps-menu">
          <Steps current={current}>
            {steps.map(item => (
              <Steps.Step
                key={item.id}
                title={t(`opportunity:wizard.steps.${item.id}`)}
              />
            ))}
          </Steps>
        </div>
        <div className="steps-content">
          {!R.isEmpty(selected) && (
            <StepContent opportunity={selected} initialValues={initialValues} />
          )}
        </div>
      </div>
    </Container>
  );
};

const enhancer = compose(
  withRouter,
  withTranslation(["global"]),
  connect((state, { location }) => ({
    company: state.company,
    current: state.opportunity.step || 0,
    selected: state.opportunity.selected,
    initialValues: qs.parse(location.search, { ignoreQueryPrefix: true })
  })),
  dispatchOnMount(({ company }) =>
    NEW_OPPORTUNITY.run({ company: company.id })
  ),
  dispatchOnUnmount(DESELECT_OPPORTUNITY.run)
);

export default enhancer(NewOpportunity);
